import mainStyle from "./mainStyle.module.scss";
import React, { useState, useEffect, memo } from 'react';
import { cloneDeep } from "lodash";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { SolidButton } from "components/buttons/SolidButton";
import { OutlineButton } from "components/buttons/OutlineButton";

const ModalforCheck = (props) => {
  const {
    title, content, 
    cancelBtn, saveBtn,
    setOpenModal, onBottonClick
  } = props;
  const theme = useTheme();

  let contentTxt = cloneDeep(content);
  let contentTxtAry = null;

  if(title === 'Custom Inform Host'){
    contentTxt = null
    contentTxtAry = content.split('</br>')
  }

  const handleClose = () => {
    onBottonClick('close')
    setOpenModal(false);
  };

  const handleSave = () => {
    onBottonClick('ok')
    setOpenModal(false);
  };

  return (
    <>
      <div className={mainStyle['modal_Block']} style={{margin:'10px 0px 20px 0px'}}>
        {title &&
          <Typography
            sx={{
              color: theme.palette.primary.main,
              fontSize: theme.typography.customFontSize[5],
              fontWeight: theme.typography.customFontWeight[3],
              fontFamily: theme.typography.fontFamily,
            }}
            >
            {title}
          </Typography>
        }
        {/* <IconButton style={newOpenTheme} onClick={handleClose}>
          <img src={close} alt="openInNew" width={"25px"} />
        </IconButton> */}
      </div>
      {contentTxt && <div className={mainStyle['modal_Block']} style={{margin: '15px 10px 25px 10px', textAlign:'center'}}>
        <Typography
          sx={{
            color: theme.palette.primary.greyPrimary,
            fontSize: theme.typography.customFontSize[4],
            fontFamily: theme.typography.fontFamily,
          }}
          >
          {contentTxt}
        </Typography>
      </div>}
      {contentTxtAry && <div style={{margin: '15px 10px 25px 10px'}}>
        {contentTxtAry.map((content) => (
          <Typography
            sx={{
              color: theme.palette.primary.greyPrimary,
              fontSize: theme.typography.customFontSize[4],
              fontFamily: theme.typography.fontFamily,
            }}
            >
            {content}
          </Typography>
        ))}
      </div>}
      <div className={mainStyle['modal_Block']}>
        {cancelBtn && <Box style={{margin: '10px'}}>
          <OutlineButton width="135px" height="42px" onClick={handleClose}>
          {cancelBtn}
          </OutlineButton>
        </Box>}
        {saveBtn && <Box style={{margin: '10px'}}>
          <SolidButton width="135px" height="42px" onClick={handleSave}>
            {saveBtn}
          </SolidButton>
        </Box>}
      </div>
    </>
  );
}

export default memo(ModalforCheck);